import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-3c35fdfd"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "tabs is-boxed" };
const _hoisted_2 = ["onClick"];
const _hoisted_3 = { key: 0 };
const _hoisted_4 = { key: 0 };
const _hoisted_5 = { key: 2 };
import { canSeeFeature } from '@/core/session';
import OpenTasksIndicator from '@/features/tasks/OpenTasksIndicator.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'TabsHeader',
    props: {
        modelValue: {},
        tabs: {},
        annotations: {},
        entityType: {},
        entityId: {}
    },
    emits: ['update:modelValue'],
    setup(__props, { emit: __emit }) {
        const emit = __emit;
        const changeTab = (newTab) => {
            emit('update:modelValue', newTab);
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("ul", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tabName, tabId) => {
                        var _a, _b, _c, _d, _e, _f;
                        return (_openBlock(), _createElementBlock("li", {
                            key: tabId,
                            class: _normalizeClass({ 'is-active': _ctx.modelValue == tabName }),
                            onClick: ($event) => (changeTab(tabName))
                        }, [
                            (tabId == 'TASKS')
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    (_unref(canSeeFeature)('tasks'))
                                        ? (_openBlock(), _createElementBlock("a", _hoisted_3, [
                                            _createTextVNode(_toDisplayString(tabName) + " ", 1),
                                            _createVNode(OpenTasksIndicator, {
                                                entityType: _ctx.entityType,
                                                entityId: _ctx.entityId
                                            }, null, 8, ["entityType", "entityId"])
                                        ]))
                                        : _createCommentVNode("", true)
                                ], 64))
                                : (tabId == 'LIFT_2_0')
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                        (_unref(canSeeFeature)('lift_2_0'))
                                            ? (_openBlock(), _createElementBlock("a", _hoisted_4, [
                                                _createTextVNode(_toDisplayString(tabName) + " ", 1),
                                                ((_a = _ctx.annotations) === null || _a === void 0 ? void 0 : _a[tabId])
                                                    ? (_openBlock(), _createElementBlock("span", {
                                                        key: 0,
                                                        class: _normalizeClass(["tag is-rounded has-text-weight-bold annotationTag ml-1", (_b = _ctx.annotations) === null || _b === void 0 ? void 0 : _b[tabId].class])
                                                    }, _toDisplayString((_c = _ctx.annotations) === null || _c === void 0 ? void 0 : _c[tabId].label), 3))
                                                    : _createCommentVNode("", true)
                                            ]))
                                            : _createCommentVNode("", true)
                                    ], 64))
                                    : (_openBlock(), _createElementBlock("a", _hoisted_5, [
                                        _createTextVNode(_toDisplayString(tabName) + " ", 1),
                                        ((_d = _ctx.annotations) === null || _d === void 0 ? void 0 : _d[tabId])
                                            ? (_openBlock(), _createElementBlock("span", {
                                                key: 0,
                                                class: _normalizeClass(["tag is-rounded has-text-weight-bold annotationTag ml-1", (_e = _ctx.annotations) === null || _e === void 0 ? void 0 : _e[tabId].class])
                                            }, _toDisplayString((_f = _ctx.annotations) === null || _f === void 0 ? void 0 : _f[tabId].label), 3))
                                            : _createCommentVNode("", true)
                                    ]))
                        ], 10, _hoisted_2));
                    }), 128))
                ])
            ]));
        };
    }
});
